import { tps_setCookie } from './globals';

export function tps_handleAlertBannerDismiss(event) {
  var elem = event.currentTarget;
  var banner = document.getElementById('tps-header-notification-banner');
  var cookieName = elem.dataset.tpsCookieName;
  var cookieValue = elem.dataset.tpsCookieValue;
  // hide the banner
  banner.classList.add('hide');
  // set the cookie
  if (cookieName && cookieValue) {
    tps_setCookie(cookieName, cookieValue);
  }
}

window.tps_handleAlertBannerDismiss = tps_handleAlertBannerDismiss;



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/header-notifications.js